import _ from 'underscore';
import { segmentationTypeEnum } from './segmentation-type-enum';
import { segmentationTree } from './segmentation-tree';

// Return value has structure same as
// 1. we used in @bingads-webui/json-tree-parser
// 2. segmentationTree
export function getSupportedSegmentationTree({
  permissions = {},
  segmentationTypes = segmentationTypeEnum,
}) {
  const isSupported = type => _.contains(['None', ...segmentationTypes], type);
  const hasPermission = permission => !permission || permissions[permission];

  return _.compact(_.map(segmentationTree, ({ permission, children, name }) => {
    if (!hasPermission(permission)) {
      return null;
    }

    if (children) {
      const allowed = _.filter(
        children,
        childItem => isSupported(childItem.name) && hasPermission(childItem.permission)
      );

      return _.isEmpty(allowed) ? null : {
        name,
        children: allowed,
      };
    }

    if (isSupported(name)) {
      return { name };
    }

    return null;
  }));
}
